var map = {
	"./tech-gray-chatgpt.svg": 1334,
	"./tech-gray-excel.svg": 1335,
	"./tech-gray-git.svg": 1336,
	"./tech-gray-google-sheets.svg": 1337,
	"./tech-gray-jupyter.svg": 1338,
	"./tech-gray-multiple.svg": 1339,
	"./tech-gray-other.svg": 1340,
	"./tech-gray-powerbi.svg": 1341,
	"./tech-gray-python.svg": 1342,
	"./tech-gray-r.svg": 1343,
	"./tech-gray-sql.svg": 1344,
	"./tech-gray-tableau.svg": 1345,
	"./tech-gray-theory.svg": 1346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3470;